import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import de from 'date-fns/locale/de'; // Importing German locale
import calendarIcon from '../assets/calendar.png';

registerLocale('de', de); // Register the German locale
setDefaultLocale('de'); // Set it as the default locale

const CustomDatePicker = ({ onDateChange, name, selectedDate }) => {
    const [value, setValue] = useState(selectedDate || new Date(1990, 0, 1));
    const [showYearDropdown, setShowYearDropdown] = useState(false);
    const [showMonthDropdown, setShowMonthDropdown] = useState(false);
    const [selectedYear, setSelectedYear] = useState(1990);
    const [selectedMonth, setSelectedMonth] = useState(0);

    const years = Array.from({ length: 101 }, (_, i) => new Date().getFullYear() - i);
    const months = [
        "Januar", "Februar", "März", "April", "Mai", "Juni",
        "Juli", "August", "September", "Oktober", "November", "Dezember"
    ];

    useEffect(() => {
        if (name) {
            setValue(name);
        }
    }, [name]);

    const handleYearSelect = (year, changeYear) => {
        setSelectedYear(year);
        changeYear(year);
        setShowYearDropdown(false);
    };

    const handleMonthSelect = (monthIndex, changeMonth) => {
        setSelectedMonth(monthIndex);
        changeMonth(monthIndex);
        setShowMonthDropdown(false);
    };

    const handleMonthChange = (direction, date, changeMonth, changeYear) => {
        let currentMonth = date.getMonth();
        let currentYear = date.getFullYear();
        let newMonth = currentMonth + direction;

        if (newMonth < 0) {
            newMonth = 11;
            currentYear -= 1;
        } else if (newMonth > 11) {
            newMonth = 0;
            currentYear += 1;
        }

        setSelectedMonth(newMonth);
        setSelectedYear(currentYear);
        changeMonth(newMonth);
        changeYear(currentYear);
    };

    const handleDateChange = (date) => {
        setValue(date);
        onDateChange(date);
    
        const storedFormValues = JSON.parse(localStorage.getItem("formValues")) || {};
        storedFormValues.dateOfBirth = date;
        localStorage.setItem("formValues", JSON.stringify(storedFormValues));
    };

    return (
        <div className="date-picker-container">
            <DatePicker
                selected={value}
                onChange={handleDateChange}
                dateFormat="dd/MM/yyyy"
                placeholderText="Wählen Sie Ihr Geburtsdatum"
                locale="de"
                calendarStartDay={0} // Explicitly set week to start on Sunday (0)
                renderCustomHeader={({
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                }) => (
                    <div
                        style={{
                            margin: 10,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}>
                        <button
                            onClick={() =>
                                handleMonthChange(-1, date, changeMonth, changeYear)
                            }
                            disabled={prevMonthButtonDisabled}>
                            {"<"}
                        </button>

                        <div>
                            <button
                                onClick={() => setShowMonthDropdown(!showMonthDropdown)}
                                style={{
                                    padding: "5px 10px",
                                    border: "1px solid #ccc",
                                    cursor: "pointer",
                                }}>
                                {months[selectedMonth]}
                            </button>
                            {showMonthDropdown && (
                                <div
                                    style={{
                                        position: "absolute",
                                        maxHeight: "200px",
                                        overflowY: "scroll",
                                        backgroundColor: "#fff",
                                        border: "1px solid #ccc",
                                        zIndex: 10,
                                    }}>
                                    {months.map((month, index) => (
                                        <div
                                            key={month}
                                            style={{
                                                padding: "5px",
                                                cursor: "pointer",
                                                backgroundColor:
                                                    selectedMonth === index ? "#ddd" : "#fff",
                                            }}
                                            onClick={() => handleMonthSelect(index, changeMonth)}>
                                            {month}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div style={{ marginLeft: "10px" }}>
                            <button
                                onClick={() => setShowYearDropdown(!showYearDropdown)}
                                style={{
                                    padding: "5px 10px",
                                    border: "1px solid #ccc",
                                    cursor: "pointer",
                                }}>
                                {selectedYear}
                            </button>
                            {showYearDropdown && (
                                <div
                                    style={{
                                        position: "absolute",
                                        maxHeight: "200px",
                                        overflowY: "scroll",
                                        backgroundColor: "#fff",
                                        border: "1px solid #ccc",
                                        zIndex: 10,
                                    }}>
                                    {years.map((year) => (
                                        <div
                                            key={year}
                                            style={{
                                                padding: "5px",
                                                cursor: "pointer",
                                                backgroundColor:
                                                    selectedYear === year ? "#ddd" : "#fff",
                                            }}
                                            onClick={() => handleYearSelect(year, changeYear)}>
                                            {year}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <button
                            onClick={() =>
                                handleMonthChange(1, date, changeMonth, changeYear)
                            }
                            disabled={nextMonthButtonDisabled}>
                            {">"}
                        </button>
                    </div>
                )}
            />
            <img
                src={calendarIcon}
                alt="Calendar Icon"
                className="calendar-icon"
                style={{
                    position: "absolute",
                    right: "10px",
                    top: "52px",
                    pointerEvents: "none",
                }}
            />
        </div>
    );
};

export default CustomDatePicker;